import { CompaniesTargetListBuildType, CompaniesTargetListItemType } from '../../account/models/companies-target-lists.models';

export type OrderDirection = 'desc' | 'asc';

export interface KeyValuePair<TKey = string> {
  id: TKey;
  name: string;
}

export interface KeyValueGroup {
  groupName: string;
  items: KeyValuePair[];
}

export interface RecordsResponse<T> {
  total: number;
  data: T[];
}

export interface DataResponse<T> {
  data: T;
}

export interface SelectOption<T> {
  label: string,
  value: T
}

export interface AccountAsset {
  id: number;
  name: string;
  features: string[];
}

export interface GenericKeyValuePair<TKey, TValue> {
  id: TKey;
  name: TValue;
}

export type GoalOrEvent = 'Event' | 'Goal';

export interface AccountGoal {
  id: number;
  name: string;
  type: GoalType;
  status: Status;
  actionType: GoalOrEvent;
}

export interface AbmTargetList {
  list_id: number;
  list_name: string;
  list_type: CompaniesTargetListItemType;
  build_type: CompaniesTargetListBuildType;
}

export interface AccountArea {
  areaId: number;
  by: string;
  contentType: 'none' | 'general' | 'content';
  pattern: string;
  name: string;
}

export interface AccountCta {
  id: number;
  name: string;
  type: string;
  behavior: string;
  status: string;
}

export enum Status {
  'Active' = 1,
  'Paused' = 2,
  'Closed' = 3,
}

export enum UnitStatus {
  'Active' = 1,
  'Paused' = 2,
  'Closed' = 3,
  'Scheduled' = 4,
  'Expired' = 5
}

export const statusesSelect: KeyValuePair[] = [
  { id: null, name: 'All' },
  { id: Status.Active.toString(), name: 'Active' },
  { id: Status.Paused.toString(), name: 'Paused' },
  { id: Status.Closed.toString(), name: 'Deleted' }
];

export interface StatusRequest {
  status: Status;
}

/*export enum GoalType {
  GOURL = 1,
  PAGEVIEWS = 2,
  ACTIONCONVERSION = 3,
  BUTTONCLICK = 4,
  THIRDPARTY = 5
}*/

export enum GoalType {
  'Destination' = 1,
  'Action Conversion' = 3,
  'Button click' = 4,
  '3rd party' = 5
}

export interface Country {
  label: string;
  code_country: string;
  code_state: string;
}

export interface State {
  id: string;
  name: string;
}

export interface GoalStats {
  id: string;
  count: number;
  contentInfluancePercent?: number;
  changePercent?: number;
  period?: number;
}

export interface DashboardNavigatorItem {
  title: string;
  icon: string;
  links: { avatar: string; text: string; href: string }[];
}

export interface PageTag {
  id: number;
  name: string;
  autoGenerated: boolean;
}

export interface IdNamePair {
  id: string;
  name: string;
}

export interface ChangeOrderRequest {
  ids: number[];
}

export enum AiPoolContentType {
  Autopilot = 0,
  ContexTiles = 1
}

export interface ListRequestModel {
  offset: number;
  limit: number;
  orderBy: string;
  direction: OrderDirection;
  search: string;
}
